import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import type { IWelcomeInvitationResponse } from "@/models"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { WelcomeInvitation } from "@/models"

export interface IGetInvitationWelcomeArgsParams {
  accessToken?: string
  token?: string
  eventAlbumId?: number
}

export async function getInvitationWelcome(eventVaultId: number, accessToken?: string, token?: string, albumId?: number) {
  const options: AxiosRequestConfig = {}
  const params: IGetInvitationWelcomeArgsParams = {}

  if (accessToken) {
    params.accessToken = accessToken
  }

  if (token) {
    params.token = token
  }

  if (albumId) {
    params.eventAlbumId = albumId
  }

  if (params.accessToken || params.token || params.eventAlbumId) {
    options.params = params
  }

  const response = await v1.get<ServerResponseV1<IWelcomeInvitationResponse>>(`/guest/${eventVaultId}/welcome`, options)

  return WelcomeInvitation.fromResponse(response.data.data)
}

export const GET_INVITATION_WELCOME = "getInvitationWelcome"

export function useGetInvitationWelcome(accessToken?: MaybeRef<string | undefined>, token?: MaybeRef<string | undefined>, eventVaultId?: MaybeRef<number | undefined>, albumId?: MaybeRef<number | undefined>) {
  return useQuery({
    queryKey: [GET_INVITATION_WELCOME, accessToken, token, eventVaultId, albumId],
    queryFn: () => getInvitationWelcome(toValue(eventVaultId)!, toValue(accessToken), toValue(token), toValue(albumId)),
    enabled: !!toValue(eventVaultId),
  })
}
